interface NewsBlockTitleProps {
  title?: string;
}

const NewsBlockTitle = ({ title }: NewsBlockTitleProps) => {
  return (
    <div>
      <div className="text-lg text-text-500">{title}</div>
    </div>
  );
};

export default NewsBlockTitle;
